/**
 * GroupInvitationModal Styles
 */

import { StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const getGroupInvitationModalStyles = (theme: Theme) =>
  StyleSheet.create({
    contentCard: {
      backgroundColor: theme.background.card,
      borderRadius: 20,
      paddingHorizontal: 20,
      paddingVertical: 16,
      width: '92%',
      maxWidth: 500,
      maxHeight: '92%',
      minHeight: '80%',
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 16,
    },
    headerTitle: {
      flex: 1,
      fontSize: 20,
      fontWeight: '700',
      color: theme.gray[900],
    },
    closeButton: {
      padding: 4,
      marginLeft: 8,
    },
    tabRow: {
      flexDirection: 'row',
      marginBottom: 12,
      backgroundColor: theme.gray[100],
      borderRadius: 10,
      padding: 4,
    },
    tab: {
      flex: 1,
      paddingVertical: 10,
      alignItems: 'center',
      borderRadius: 8,
    },
    tabActive: {
      backgroundColor: theme.background.cardElevated,
      shadowColor: theme.shadow,
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.08,
      shadowRadius: 2,
      elevation: 2,
    },
    tabText: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.gray[600],
    },
    tabTextActive: {
      color: theme.primary,
    },
    body: {
      flex: 1,
      minHeight: 320,
      marginBottom: 16,
    },
    /** Wrapper for inactive tab so it stays mounted but hidden (avoids remount snap when switching back). */
    tabPanelHidden: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      opacity: 0,
      pointerEvents: 'none',
    },
    tabPanelVisible: {
      flex: 1,
    },
    addButton: {
      backgroundColor: theme.primary,
      borderRadius: 12,
      paddingVertical: 14,
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 48,
    },
    addButtonDisabled: {
      backgroundColor: theme.gray[400],
    },
    addButtonAtCap: {
      backgroundColor: theme.warning ?? theme.gray[700],
    },
    addButtonPressed: {
      opacity: 0.8,
    },
    addButtonHover: {
      opacity: 0.9,
    },
    addButtonText: {
      fontSize: 16,
      fontWeight: '600',
      color: theme.onPrimary,
    },
    closeButtonPressed: {
      opacity: 0.6,
    },
    closeButtonHover: {
      opacity: 0.7,
    },
    tabPressed: {
      opacity: 0.7,
    },
    tabHover: {
      opacity: 0.85,
    },
  })
